import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  deleteCartItem,
  removeCartItem,
  updateCartItem,
} from "../../../store/slices/CartSlice/CartSlice";
import ItemCounter from "../ItemCounter/ItemCounter";
import Button from "../Button";

export default function CartItemCounter({
  cartItem,
  className,
  handleCartRemoval,
}) {
  const [confirmRemoveFromCart, setConfirmRemoveFromCart] = useState(false);
  const dispatch = useDispatch();

  const handleRemoveCartItem = () => {
    setConfirmRemoveFromCart(false);
    if (handleCartRemoval) handleCartRemoval(cartItem);
    dispatch(removeCartItem(cartItem));
    dispatch(deleteCartItem({ key: cartItem.cart_item_key }));
  };

  const incrementQty = () => {
    dispatch(
      updateCartItem({
        ...cartItem,
        quantity: cartItem.quantity !== "" ? cartItem.quantity + 1 : 1,
      })
    );
  };

  const decrementQty = () => {
    if (cartItem.quantity !== "" && cartItem.quantity - 1 <= 0) {
      setConfirmRemoveFromCart(true);
    } else {
      dispatch(
        updateCartItem({
          ...cartItem,
          quantity: cartItem.quantity !== "" ? cartItem.quantity - 1 : 0,
        })
      );
    }
  };

  const handleValueChange = (event) => {
    const newValue = event.target.value;
    const isDigit = /^[0-9]+$/.test(newValue);
    if (newValue === "" || isDigit) {
      let useVal;
      if (isDigit) {
        useVal = parseFloat(newValue);
      }
      dispatch(updateCartItem({ ...cartItem, quantity: useVal || newValue }));
    }
  };

  const checkToRemoveItem = () => {
    if (cartItem.quantity === "" || cartItem.quantity <= 0)
      setConfirmRemoveFromCart(true);
  };

  return (
    <>
      {confirmRemoveFromCart ? (
        <div className="flex gap-2 max-h-8 ">
          <Button
            type={"positive"}
            textContent="Cancel"
            onClick={() => setConfirmRemoveFromCart(false)}
          />
          <Button
            type={"negative"}
            textContent="Remove"
            onClick={handleRemoveCartItem}
          />
        </div>
      ) : (
        <ItemCounter
          show={cartItem}
          value={cartItem?.quantity}
          incrementFunction={incrementQty}
          decrementFunction={decrementQty}
          customOnChange={handleValueChange}
          onBlur={checkToRemoveItem}
        />
      )}
    </>
  );
}
